export default __webpack_public_path__ + "static/media/white_ticket.a802fd2d.svg";